 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"Marksview1Component-Marksview1Component-module":"Marksview1Component-Marksview1Component-module","Marksview2Component-Marksview2Component-module":"Marksview2Component-Marksview2Component-module","Marksview3Component-Marksview3Component-module":"Marksview3Component-Marksview3Component-module","card-card-module":"card-card-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a":"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a","attendance-attendance-module":"attendance-attendance-module","default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5":"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5","alumni-alumni-module":"alumni-alumni-module","default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e":"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e","carpools-carpools-module":"carpools-carpools-module","default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed":"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed","classes-classes-module":"classes-classes-module","custom-sms-custom-sms-module":"custom-sms-custom-sms-module","default~allstudents-allstudents-module~school-school-module":"default~allstudents-allstudents-module~school-school-module","allstudents-allstudents-module":"allstudents-allstudents-module","default~classwork-classwork-module~events-events-module~gallery-gallery-module":"default~classwork-classwork-module~events-events-module~gallery-gallery-module","classwork-classwork-module":"classwork-classwork-module","expense-expense-module":"expense-expense-module","fee-define-fee-define-module":"fee-define-fee-define-module","homework-homework-module":"homework-homework-module","default~magazine-magazine-module~school-school-module~teachers-teachers-module~toppers-toppers-modul~a88554d9":"default~magazine-magazine-module~school-school-module~teachers-teachers-module~toppers-toppers-modul~a88554d9","default~holidays-holidays-module~toppers-toppers-module":"default~holidays-holidays-module~toppers-toppers-module","toppers-toppers-module":"toppers-toppers-module","magazine-magazine-module":"magazine-magazine-module","non-teaching-non-teaching-module":"non-teaching-non-teaching-module","default~child-child-module~events-events-module~gallery-gallery-module":"default~child-child-module~events-events-module~gallery-gallery-module","events-events-module":"events-events-module","results-results-module":"results-results-module","default~child-child-module~fee-fee-module~school-school-module":"default~child-child-module~fee-fee-module~school-school-module","school-school-module":"school-school-module","teachers-teachers-module":"teachers-teachers-module","visitors-visitors-module":"visitors-visitors-module","gallery-gallery-module":"gallery-gallery-module","fee-fee-module":"fee-fee-module","excel-reports-excel-reports-module":"excel-reports-excel-reports-module","libraries-libraries-module":"libraries-libraries-module","marks-assign-marks-assign-module":"marks-assign-marks-assign-module","report-report-module":"report-report-module","request-request-module":"request-request-module","routines-routine-module":"routines-routine-module","holidays-holidays-module":"holidays-holidays-module","uploadform-uploadform-module":"uploadform-uploadform-module","child-child-module":"child-child-module","design-certificate-design-certificate-module":"design-certificate-design-certificate-module","design-template-design-template-module":"design-template-design-template-module","designer-designer-module":"designer-designer-module","extra-details-extra-details-module":"extra-details-extra-details-module","gatecam-gatecam-module":"gatecam-gatecam-module","livestream-livestream-module":"livestream-livestream-module","online-classes-online-classes-module":"online-classes-online-classes-module","other-details-other-details-module":"other-details-other-details-module","rank-rank-module":"rank-rank-module","report-cards-report-cards-module":"report-cards-report-cards-module","tabular-tabular-module":"tabular-tabular-module","user-rights-user-rights-module":"user-rights-user-rights-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
